import {Text} from "finhelper";

/**
 * Структура объекта контакта либо клиента, идущего в эвент дашборда либо календаря
 */
export class TaskContactDTO {
    public readonly id: string; // айдишник здесь преобразован и ВСЕГДА будет с припиской '-user' или '-contact'
    public readonly clearId: number;
    public readonly innerType: 'user' | 'contact';
    public readonly last_name: string;
    public readonly first_name: string;
    public readonly name: string;
    public readonly avatar?: string;

    constructor(data: {
        id: string;
        clearId: number;
        innerType: 'user' | 'contact';
        last_name: string;
        first_name: string;
        name: string;
        avatar?: string;
    }) {
        this.id = data.id;
        this.clearId = data.clearId;
        this.innerType = data.innerType;
        this.last_name = data.last_name;
        this.first_name = data.first_name;
        this.name = data.name;
        this.avatar = data.avatar;
    }

    public static fromRaw(
        item: { id: number; last_name?: string; first_name?: string; email?: string; avatar?: string },
        type: 'user' | 'contact'
    ): TaskContactDTO {
        return new TaskContactDTO({
            id: `${item.id}-${type}`,
            clearId: item.id,
            innerType: type,
            last_name: item.last_name ?? '',
            first_name: item.first_name ?? '',
            name: Text.fio(item) + (item.email ? ` (${item.email})` : ''),
            avatar: item.avatar,
        });
    }

    public static fromArray(
        items: Array<{ id: number; last_name?: string; first_name?: string; email?: string; avatar?: string }>,
        type: 'user' | 'contact'
    ): TaskContactDTO[] {
        return items.map((item) => TaskContactDTO.fromRaw(item, type));
    }

    public toJSON(): {
        id: string;
        clearId: number;
        innerType: 'user' | 'contact';
        last_name: string;
        first_name: string;
        name: string;
        avatar?: string;
    } {
        return {
            id: this.id,
            clearId: this.clearId,
            innerType: this.innerType,
            last_name: this.last_name,
            first_name: this.first_name,
            name: this.name,
            avatar: this.avatar,
        };
    }
}